import i18next from 'i18next';
import download from 'downloadjs';

const DATE_FORMAT = 'yyyy/mm/dd';

export function getStartPoint(item) {
  if (item.Points && item.Points.length) {
    return (
      [...item.Points]
        .filter((point) => point.x !== null && point.y !== null)
        .sort((a, b) => b.x - a.x || b.y - a.y)
        .pop() || {}
    );
  }
  if (item.PointX !== null && item.PointY !== null) {
    return { x: item.PointX, y: item.PointY };
  }
  return {};
}

export function getEndPoint(item) {
  if (item.Points && item.Points.length) {
    return (
      [...item.Points]
        .filter((point) => point.x !== null && point.y !== null)
        .sort((a, b) => a.x - b.x || a.y - b.y)
        .pop() || {}
    );
  }
  if (item.EndPointX !== null && item.EndPointY !== null) {
    return { x: item.EndPointX, y: item.EndPointY };
  }
  if (item.PointX !== null || item.PointY !== null) {
    return { x: item.PointX, y: item.PointY };
  }
  return {};
}

export function formatDate(value) {
  if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}T/)) {
    return i18next.format(new Date(value), DATE_FORMAT);
  }
  if (value instanceof Date) {
    return i18next.format(value, DATE_FORMAT);
  }
  return value;
}

export function getDrawingWithImage(drawing, drawingSystems) {
  if (drawing.HasImage) {
    return {
      ...drawing,
      Image: `/api/drawings/${drawing.Id}/image`,
    };
  }
  if (drawing.SystemNumber) {
    const system = drawingSystems.find(
      (s) => s.Number === drawing.SystemNumber
    );
    if (system && system.HasImage) {
      return {
        ...drawing,
        Image: `/api/drawingSystems/${system.Id}/image`,
      };
    }
  }
  return drawing;
}

export const CommentPermissions = {
  // Comment out inorder to undo if this feature is need in the future
  //Public: 1,
  Private: 2,
  Shared: 3,
};

export async  function fetchImage(url,type, token) {
  var headers = new Headers({
    Authorization: `${token.token_type} ${token.access_token}`,
  });

  var options = {
    method: 'GET',
    headers: headers,
  };

  var request = new Request(url);
  let response = await fetch(request, options) ;
  let imageBuffer =  await response.arrayBuffer();
  let imageType = type === 'svg' ? 'svg+xml'
                : type === 'jpg' ? 'jpeg'
                : type;
  let base64Flag = 'data:image/' + imageType + ';base64,';
  let imageStr = arrayBufferToBase64(imageBuffer);
  let imageSrc = base64Flag + imageStr;
  return imageSrc;
}

// Convert image buffer to base64
function arrayBufferToBase64(buffer) {
 var binary = '';
  var bytes = [].slice.call(new Uint8Array(buffer));
 bytes.forEach((b) => (binary += String.fromCharCode(b)));
 return window.btoa(binary);
        }

export function fetchFile ( url, token) {
  var headers = new Headers({
    Authorization: `${token.token_type} ${token.access_token}`,
  });

  var options = {
    method: 'GET',
    headers: headers,
    responseType: 'blob',
  };

    var request = new Request(url);

  fetch(request, options).then((response) => {
    response.arrayBuffer().then((buffer) => {
      download(new Blob([buffer]), "download.pdf", "application/octet-stream");
    });
  }).catch(error => {
    console.log(error);
});
}
